import { render, staticRenderFns } from "./action-sheet-picker.mpx?vue&type=template&id=3de4844e&isComponent&outputPath=components%2Faction-sheet-pickerb0594ee2%2Findex"
import script from "./action-sheet-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Faction-sheet-pickerb0594ee2%2Findex"
export * from "./action-sheet-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Faction-sheet-pickerb0594ee2%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports